export interface PortfolioCase {
  id: number;
  image: string;
  tag: string;
  tagKey: string;
  title: string;
  desc: string;
  points: string[];
  method?: "prefab" | "traditional" | "hybrid";
  detail?: {
    siteInfo: { area: string; location: string; duration: string; floors: string };
    designConcept: string;
    constructionHighlights: string[];
    ownerFeedback: string;
  };
}

export const portfolioCases: PortfolioCase[] = [
  {
    id: 1,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20luxury%20steel%20frame%20house%20exterior%20with%20clean%20geometric%20lines%2C%20warm%20wood%20and%20concrete%20facade%2C%20large%20glass%20windows%2C%20landscaped%20garden%20front%20yard%2C%20golden%20hour%20sunlight%2C%20premium%20architectural%20photography%2C%20warm%20cream%20and%20charcoal%20tones%2C%20high-end%20residential%20design%2C%20editorial%20quality%20with%20soft%20shadows%20on%20light%20background&width=800&height=560&seq=101&orientation=landscape",
    tag: "已有土地・自地自建",
    tagKey: "portfolio.filter.selfBuild",
    title: "從空地到理想宅，一次整合建築與生活機能",
    desc: "適合已經有土地，但不確定法規、預算與建築配置的業主。透過前期評估、建築設計與室內規劃，讓基地條件轉化為可執行的住宅藍圖。",
    points: ["土地條件盤點", "預算級距評估", "建築外觀與室內動線整合"],
    method: "prefab",
    detail: {
      siteInfo: { area: "約 120 坪", location: "新竹縣竹北市", duration: "10 個月", floors: "地上 3 層" },
      designConcept: "業主希望打造一棟既能展現現代建築美學，又能融入台灣生活習慣的住宅。設計團隊以「開放與隱私的平衡」為核心，將公共空間打開，讓光線與空氣自由流動，同時透過樓層配置確保每個家庭成員的私密空間。",
      constructionHighlights: ["預製鋼構主結構，現場組裝僅 4 個月", "高性能 Low-E 玻璃搭配外遮陽系統", "屋頂綠化與雨水回收整合設計"],
      ownerFeedback: "從一開始的空地到現在每天回家看到的房子，過程比我們想像的順利很多。尤其是施工期間，團隊的進度掌控和品質監造讓我們很放心。",
    },
  },
  {
    id: 2,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20multi-generation%20family%20house%20interior%20with%20open%20living%20space%2C%20warm%20wood%20tones%2C%20natural%20light%2C%20comfortable%20seating%20area%2C%20contemporary%20design%20suitable%20for%20elderly%20and%20young%20families%2C%20spacious%20hallway%2C%20architectural%20interior%20photography%2C%20warm%20neutral%20palette%20with%20soft%20lighting%2C%20cream%20and%20charcoal%20tones%2C%20editorial%20quality&width=800&height=560&seq=102&orientation=landscape",
    tag: "家族土地・多代同堂",
    tagKey: "portfolio.filter.multiGen",
    title: "讓三代同堂住得近，也住得自在",
    desc: "針對家庭成員多、生活作息不同的基地，規劃公共空間、私領域、長輩房與收納動線，兼顧親密與隱私。",
    points: ["多代同堂動線", "長輩友善空間", "家庭公共區域整合"],
    method: "hybrid",
    detail: {
      siteInfo: { area: "約 200 坪", location: "台中市潭子區", duration: "14 個月", floors: "地上 2 層 + 地下 1 層" },
      designConcept: "以「共居不互擾」為設計核心，將祖父母、父母與子女三代的生活空間分層配置。一樓設置無障礙長輩房與寬敞客餐廳，二樓為年輕夫婦與子女的私密空間，地下一樓則規劃為多功能娛樂與收納區。",
      constructionHighlights: ["電梯井預留，未來可加裝家用電梯", "全棟無障礙動線設計，走廊寬度達 120cm", "隔音牆體搭配獨立空調系統，確保各樓層舒適度"],
      ownerFeedback: "當初最擔心的是三代住在一起會互相干擾，但現在每個人都很滿意自己的空間。爸媽說一樓的無障礙設計讓他們出入很安心，孩子們也很喜歡地下室的遊戲區。",
    },
  },
  {
    id: 3,
    image:
      "https://readdy.ai/api/search-image?query=Urban%20old%20house%20renovation%20before%20and%20after%20concept%2C%20modern%20steel%20structure%20replacing%20traditional%20building%2C%20street%20view%20of%20Taiwan%20old%20house%20transformed%20into%20modern%20residence%2C%20warm%20architectural%20photography%2C%20golden%20hour%20light%2C%20cream%20and%20charcoal%20tones%2C%20premium%20real%20estate%20editorial%20style%2C%20clean%20background%20with%20soft%20shadows&width=800&height=560&seq=103&orientation=landscape",
    tag: "危老重建・賣一留一",
    tagKey: "portfolio.filter.oldRebuild",
    title: "從老屋重建到資產再配置",
    desc: "適合老屋基地、危老重建或希望透過重建提升資產價值的業主。協助評估法規、坪效、重建可行性與未來使用方式。",
    points: ["危老重建評估", "基地價值提升", "自住與資產配置兼顧"],
    method: "traditional",
    detail: {
      siteInfo: { area: "約 80 坪", location: "台南市東區", duration: "12 個月", floors: "地上 5 層" },
      designConcept: "業主希望保留一戶自住，同時將其餘單位作為出租資產。設計上採用「賣一留一」策略，自住戶位於頂樓享有露台與景觀，其餘樓層為獨立套房式出租單位，各自擁有完整廚衛機能。",
      constructionHighlights: ["危老重建獎勵容積申請，提升坪效 30%", "獨立水電表設計，各戶計費清楚", "耐震結構補強與防火隔間達最新法規標準"],
      ownerFeedback: "原本的老房子根本住不下去，現在頂樓的自住空間比我們以前整棟還舒服。樓下的出租單位每個月都有穩定收入，這個重建決定真的很值得。",
    },
  },
  {
    id: 4,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20countryside%20villa%20with%20panoramic%20mountain%20and%20forest%20view%2C%20large%20glass%20windows%20blending%20indoor%20and%20outdoor%20spaces%2C%20wooden%20deck%20terrace%2C%20natural%20landscape%20architecture%2C%20morning%20mist%2C%20premium%20architectural%20photography%2C%20warm%20earth%20tones%2C%20cream%20and%20charcoal%20color%20palette%2C%20editorial%20quality%20with%20serene%20natural%20background&width=800&height=560&seq=104&orientation=landscape",
    tag: "農地自建・景觀建築",
    tagKey: "portfolio.filter.farm",
    title: "把自然景觀變成家的日常",
    desc: "適合重視景觀、採光、戶外生活與自然環境的住宅規劃。透過建築座向、開窗、露台與室內外動線整合，創造度假感生活。",
    points: ["景觀視野設計", "自然採光與通風", "室內外生活串聯"],
    method: "prefab",
    detail: {
      siteInfo: { area: "約 300 坪", location: "南投縣埔里鎮", duration: "11 個月", floors: "地上 2 層" },
      designConcept: "基地坐擁山谷與遠山景觀，設計理念是「讓風景走進家裡」。以大面積落地玻璃作為建築與自然的介面，二樓主臥與露台形成觀景平台，一樓挑高客廳則引入庭院綠意與山嵐。",
      constructionHighlights: ["座向精算，冬季迎陽、夏季引風", "無邊際露台結構設計，視覺延伸至山景", "雨水花園與生態草溝，融入自然排水系統"],
      ownerFeedback: "每天起床看到窗外的山景和雲海，感覺就像住在度假村。雨季時坐在挑高客廳看著山嵐飄過，那種感覺是買成屋永遠體會不到的。",
    },
  },
  {
    id: 5,
    image:
      "https://readdy.ai/api/search-image?query=Accessible%20barrier-free%20modern%20home%20interior%2C%20single-story%20accessible%20design%20with%20wide%20hallways%2C%20natural%20light%2C%20minimalist%20warm%20interior%2C%20comfortable%20senior%20living%20space%2C%20wheelchair%20friendly%20design%2C%20warm%20wood%20and%20cream%20tones%2C%20premium%20architectural%20interior%20photography%2C%20clean%20lines%2C%20editorial%20quality%20with%20soft%20natural%20background&width=800&height=560&seq=105&orientation=landscape",
    tag: "退休規劃・無障礙空間",
    tagKey: "portfolio.filter.retire",
    title: "為下一階段人生預先設計",
    desc: "適合退休宅、熟齡宅或想提早規劃長住機能的家庭。重視低維護、無障礙、收納、安全與舒適溫度控制。",
    points: ["無障礙動線", "低維護材料", "長期居住舒適性"],
    method: "prefab",
    detail: {
      siteInfo: { area: "約 100 坪", location: "屏東縣潮州鎮", duration: "9 個月", floors: "地上 1 層 + 輕鋼構雨棚" },
      designConcept: "以「老後也能自在生活」為出發點，全棟單層配置免除樓梯負擔。動線上採用環形回遊設計，方便輪椅或助行器通行。材料選擇以低維護、防滑、易清潔為優先，同時保留溫潤木質感。",
      constructionHighlights: ["全棟單層設計，零階差無障礙動線", "抗潮氣密外牆系統，適應南部氣候", "緊急呼叫系統預埋管線，未來可升級智慧照護"],
      ownerFeedback: "退休後最想住的就是這種不用爬樓梯、打掃又輕鬆的房子。冬天不冷、夏天不潮，我們的老朋友來訪都說想搬來附近。",
    },
  },
  {
    id: 6,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20prefabricated%20steel%20frame%20construction%20site%2C%20factory%20precision%20manufacturing%20of%20steel%20structural%20components%2C%20clean%20industrial%20environment%20with%20workers%20assembling%20modular%20building%20parts%2C%20high-quality%20prefab%20construction%20process%2C%20warm%20architectural%20photography%20with%20professional%20lighting%2C%20cream%20and%20charcoal%20tones%2C%20editorial%20quality&width=800&height=560&seq=106&orientation=landscape",
    tag: "預製工法・高效鋼構宅",
    tagKey: "portfolio.filter.all",
    title: "用更有效率的工法，完成更穩定的住宅品質",
    desc: "透過預製工法與鋼構系統，提高施工效率、品質穩定度與現場管理效率，適合重視工期與品質的業主。",
    points: ["縮短施工期", "提升結構穩定", "降低現場變數"],
    method: "prefab",
    detail: {
      siteInfo: { area: "約 90 坪", location: "新北市林口區", duration: "7 個月", floors: "地上 3 層" },
      designConcept: "業主為工程背景出身，對施工品質與進度掌控有極高要求。本案以「透明化工地」為核心理念，從工廠預製、現場組裝到每個節點驗收，都提供完整記錄與影像回報。",
      constructionHighlights: ["70% 構件工廠預製，現場工期僅 3 個月", "BIM 建模全程導入，管線衝突預先排除", "鋼構主體 SGS 檢驗合格，結構保固 15 年"],
      ownerFeedback: "身為工程師，我很清楚傳統工地的問題。這次的預製工法讓我幾乎不用盯場，每次去現場看到的進度都跟 BIM 模擬的一模一樣，品質和時程都精準得驚人。",
    },
  },
  {
    id: 7,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20minimalist%20rooftop%20terrace%20with%20outdoor%20dining%20area%20overlooking%20city%20skyline%20at%20sunset%2C%20sleek%20steel%20and%20wood%20pergola%20structure%2C%20warm%20ambient%20string%20lights%2C%20potted%20plants%2C%20premium%20outdoor%20living%20space%20design%2C%20warm%20golden%20hour%20lighting%2C%20cream%20and%20charcoal%20tones%2C%20architectural%20photography%20with%20soft%20shadows%2C%20no%20text%20no%20people&width=800&height=560&seq=107&orientation=landscape",
    tag: "已有土地・自地自建",
    tagKey: "portfolio.filter.selfBuild",
    title: "頂樓露台與戶外生活空間整合",
    desc: "將屋頂與露台轉化為日常使用的戶外起居空間，整合遮陽、綠化與休閒機能，延伸室內生活到戶外。",
    points: ["露台防水與結構評估", "戶外機能規劃", "景觀與夜景視野整合"],
    method: "hybrid",
    detail: {
      siteInfo: { area: "約 150 坪", location: "台北市士林區", duration: "13 個月", floors: "地上 4 層 + 屋頂露台" },
      designConcept: "基地位於山坡地，擁有俯瞰台北盆地的絕佳視野。設計團隊將屋頂露台定位為「空中花園與觀星平台」，整合 Pergola 遮陽結構、戶外廚房與植栽花園，創造全天候可用的戶外生活空間。",
      constructionHighlights: ["客製化鋼構 Pergola 系統，抗風壓達 17 級", "隱藏式排水與防水層三道保護", "屋頂綠化減輕結構負荷，同時降低室內溫度 3–5°C"],
      ownerFeedback: "以前從沒想過屋頂可以這樣用。現在天氣好的時候，我們一家人最愛上露台吃早餐、晚上看夜景。朋友來都說我們家像是台北的秘密觀景台。",
    },
  },
  {
    id: 8,
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20modern%20Japanese-inspired%20courtyard%20house%20interior%2C%20zen%20garden%20visible%20through%20floor-to-ceiling%20glass%2C%20warm%20wood%20flooring%20and%20shoji%20screens%2C%20minimalist%20contemporary%20furniture%2C%20natural%20daylight%20creating%20serene%20atmosphere%2C%20premium%20residential%20interior%20design%2C%20cream%20and%20charcoal%20tones%20with%20warm%20wood%20accents%2C%20editorial%20quality%2C%20no%20text%20no%20people&width=800&height=560&seq=108&orientation=landscape",
    tag: "家族土地・多代同堂",
    tagKey: "portfolio.filter.multiGen",
    title: "日式庭院與現代住宅的和諧共存",
    desc: "融合東方庭院美學與現代居住機能，創造能讓家人放慢腳步、享受四季變化的生活場景。",
    points: ["庭院景觀與建築整合", "長輩友善的室內外動線", "自然通風與採光優化"],
    method: "traditional",
    detail: {
      siteInfo: { area: "約 180 坪", location: "台中市霧峰區", duration: "15 個月", floors: "地上 2 層 + 庭園" },
      designConcept: "業主希望打造一棟讓母親能種花、孩子能奔跑、大人能靜心閱讀的家。以「庭園為家之核心」為設計主軸，將客廳、餐廳與和室圍繞中庭配置，每個空間都能透過玻璃看到庭院四季變化。",
      constructionHighlights: ["中庭採光天井，將自然光引入建築中心", "日式庭園排水系統，兼具美觀與實用", "和室榻榻米與障子門，傳統工法與現代機能結合"],
      ownerFeedback: "媽媽說她每天早上最期待的就是看庭院裡的花開了沒。孩子們在客廳寫功課時，抬頭就能看到院子裡的樹影，我覺得這就是家的感覺。",
    },
  },
  {
    id: 9,
    image:
      "https://readdy.ai/api/search-image?query=Modern%20sustainable%20home%20with%20rainwater%20collection%20system%20and%20vertical%20garden%20walls%2C%20solar%20panels%20integrated%20into%20the%20roof%2C%20green%20roof%20garden%20with%20native%20plants%2C%20eco-friendly%20architecture%2C%20contemporary%20steel%20frame%20structure%20surrounded%20by%20natural%20landscape%2C%20warm%20afternoon%20light%2C%20premium%20architectural%20sustainability%20photography%2C%20earth%20tones%20and%20charcoal%20palette%2C%20editorial%20quality%2C%20no%20text%20no%20people&width=800&height=560&seq=109&orientation=landscape",
    tag: "農地自建・景觀建築",
    tagKey: "portfolio.filter.farm",
    title: "綠建築與永續生活空間",
    desc: "從基地微氣候出發，整合雨水回收、太陽能、綠屋頂與節能設計，打造與環境共生的低耗能住宅。",
    points: ["雨水回收與綠屋頂設計", "太陽能與節能整合", "永續建材與低碳工法"],
    method: "prefab",
    detail: {
      siteInfo: { area: "約 250 坪", location: "宜蘭縣冬山鄉", duration: "12 個月", floors: "地上 2 層" },
      designConcept: "業主為環境教育工作者，希望住家本身就能成為「永續生活的教材」。設計以「建築即生態系統」為概念，將雨水回收、太陽能發電、綠屋頂、堆肥廚餘與本土植栽整合為一個自循環的生活系統。",
      constructionHighlights: ["綠建築 EEWH 銀級認證申請中", "太陽能板與綠屋頂整合，年發電量達自用 80%", "回收雨水灌溉系統，每年節省用水 40%"],
      ownerFeedback: "這棟房子教會我們很多。孩子們會去綠屋頂觀察植物，也會看電表了解太陽能發了多少電。住進來之後，我們對『家』的想像完全不一樣了。",
    },
  },
];

export const categories = [
  { key: "portfolio.filter.all", value: "all" },
  { key: "portfolio.filter.selfBuild", value: "portfolio.filter.selfBuild" },
  { key: "portfolio.filter.multiGen", value: "portfolio.filter.multiGen" },
  { key: "portfolio.filter.oldRebuild", value: "portfolio.filter.oldRebuild" },
  { key: "portfolio.filter.farm", value: "portfolio.filter.farm" },
  { key: "portfolio.filter.retire", value: "portfolio.filter.retire" },
];

export const methodFilters = [
  { label: "全部工法", value: "all" },
  { label: "預製鋼構", value: "prefab" },
  { label: "傳統 RC", value: "traditional" },
  { label: "混合工法", value: "hybrid" },
];